module.exports = __webpack_public_path__ + "static/media/expectations.194f5a02.jpg";